
    const icons = {'check-circle': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>`,
'x': `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
}
    const defaultClass = ""

    module.exports = (name, attributes = '') => {
      var replacement = "<svg ";

      if (!icons[name]) {
        console.error('Failed to load SVG ' + name);
        return;
      }

      if (typeof attributes === "object") {
          for (let property in attributes) {
              if (attributes.hasOwnProperty(property)) {
                  let value = typeof attributes[property] == 'string'
                      ? attributes[property]
                      : JSON.stringify(attributes[property]);

                  replacement += property + "='" + value + "' ";
              }
          }
      } else {
          replacement += 'class="' + defaultClass + " " + attributes + '" ';
      }

      return icons[name].replace('<svg ', replacement);
    };
  